import { render } from "./PortalIcon.vue?vue&type=template&id=42a3996b&scoped=true"
import script from "./PortalIcon.vue?vue&type=script&lang=js"
export * from "./PortalIcon.vue?vue&type=script&lang=js"

import "./PortalIcon.vue?vue&type=style&index=0&id=42a3996b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42a3996b"]])

export default __exports__